<template>
    <el-dialog ref="textAreaDialog" :title="title" :visible.sync="visibleSync" :close-on-click-modal="false">
        <div>
            <span class="note"><i style="color: red">*</i> {{ info }}</span>
        </div>
        <div>
            <el-input style="margin-top: 30px" type="textarea" :rows="textareacount" v-model="textarea" :placeholder="textareaplaceinfo"></el-input>
        </div>
        <div slot="footer" class="dialog-footer" v-if="footerVisible">
            <el-button @click="visibleSync = false" v-if="cancelVisible">取 消</el-button>
            <el-button type="primary" @click="Confirm" v-if="okVisible">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import CloseButton from './CloseButton'
import { mapGetters } from 'vuex'
export default {
    name: `TextAreaDialog`,
    components: { CloseButton },
    props: {
        visible: Boolean,
        emit: {
            type: String,
            default: `confirm`
        },
        title: {
            type: String,
            default: `提示`
        },
        info: {
            type: String,
            default: `这里显示提示信息`
        },
        textareaplaceinfo: {
            type: String,
            default: `请输入原因`
        },
        textareacount: {
            type: Number,
            default: 3
        },
        footerVisible: {
            type: Boolean,
            default: true
        },
        okVisible: {
            type: Boolean,
            default: true
        },
        cancelVisible: {
            type: Boolean,
            default: true
        },
        required: {
            type: Boolean,
            default: true
        },
        data: Object
    },
    data() {
        return {
            emitName: this.emit,
            textarea: ``
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        }
    },
    methods: {
        Confirm() {
            let that = this
            if (that.required && that.textarea === ``) {
                this.$message.warning(that.textareaplaceinfo)
                return false
            }
            that.$emit(that.emitName, that.data, that.textarea)
        }
    },
    watch: {
    }
}
</script>
<style scoped>
.note {
    display: inline-block;
    position: absolute;
    left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/common/TextAreaDialog.vue